import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { FlatButton, IconButton } from 'material-ui';
import TrackPackage from '../TrackPackage';

class SubnavBar extends Component {
  static propTypes = {
    items: PropTypes.array,
    back: PropTypes.func,
  };

  render() {
    const { items, back } = this.props;
    const showBack = (back) ? true : false;
    let content;
    if (items) {
      content  = items.map(item => (<FlatButton key={item.key} label={item.label} onClick={item.onClick} disabled={item.disabled} />));
    }

    return (
      <div className="row">
        <div className="col s12 m8">
          {showBack &&
            <IconButton iconClassName="material-icons" onClick={browserHistory.goBack}>chevron_left</IconButton>
          }
          {content}
        </div>
        <div className="col m4">
          <div className="right-align">
            <TrackPackage />
          </div>
        </div>
      </div>
    );
  }
}

export default SubnavBar;


// WEBPACK FOOTER //
// ./src/components/SubnavBar/index.js